import Store from 'redux/Store'
import filterPages from 'shared/utils/filterPages'
import Page from 'shared/types/Page'

const getPages = (position?: string | false) => {

  const pages = Store.getState().menuPages?.pages
  let filteredPages: Page[]  = []
  
  if (typeof position != 'undefined')
    filteredPages = filterPages(pages, position)
  else
    filteredPages = pages

  return filteredPages
  
}

export default getPages
